var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoLibraryFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3276 7.54199H8.67239C5.29758 7.54199 3.61017 7.54199 2.66232 8.52882C1.71447 9.51565 1.93748 11.0403 2.38351 14.0895L2.80648 16.9811C3.15626 19.3723 3.33115 20.5679 4.22834 21.2839C5.12553 21.9999 6.4488 21.9999 9.09534 21.9999H14.9046C17.5512 21.9999 18.8745 21.9999 19.7717 21.2839C20.6689 20.5679 20.8437 19.3723 21.1935 16.9811L21.6165 14.0895C22.0625 11.0403 22.2855 9.51564 21.3377 8.52882C20.3898 7.54199 18.7024 7.54199 15.3276 7.54199ZM14.5812 15.7942C15.1396 15.448 15.1396 14.5519 14.5812 14.2057L11.2096 12.1156C10.6669 11.7792 10 12.2171 10 12.9098V17.0901C10 17.7828 10.6669 18.2207 11.2096 17.8843L14.5812 15.7942Z",
    fill: "#0098DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.51053 2.00001H15.4907C15.7231 1.99995 15.9014 1.99991 16.0572 2.01515C17.165 2.12352 18.0718 2.78958 18.4563 3.68678H5.54492C5.92943 2.78958 6.83618 2.12352 7.944 2.01515C8.09981 1.99991 8.27805 1.99995 8.51053 2.00001Z",
    fill: "#0098DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.31117 4.72266C4.92055 4.72266 3.78028 5.56241 3.39975 6.67645C3.39182 6.69967 3.38422 6.72302 3.37695 6.74647C3.7751 6.6259 4.18946 6.54713 4.60893 6.49336C5.6893 6.35485 7.05464 6.35492 8.64067 6.35501H15.5328C17.1188 6.35492 18.4842 6.35485 19.5645 6.49336C19.984 6.54713 20.3984 6.6259 20.7965 6.74647C20.7893 6.72302 20.7816 6.69967 20.7737 6.67645C20.3932 5.56241 19.2529 4.72266 17.8623 4.72266H6.31117Z",
    fill: "#0098DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLibraryFilled);
export default __webpack_public_path__ + "static/media/video-library--filled.5fc4a5ef12b2851a4bfb7c41b644e50d.svg";
export { ForwardRef as ReactComponent };